import styles from 'scss/Loading.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const Loading = () => {
  const loadingClassNames = cx({ loading: true, mask: true });
  const loadingRingClassNames = cx({ 'loading-ring': true });

  return (
    <div className={loadingClassNames}>
      <div className={loadingRingClassNames} />
    </div>
  );
};

export default Loading;
